import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from './api/http';
import MessageDialogPlugin from'./components/common/messageDialog';
import 'babel-polyfill';
import { ethers } from 'ethers'; // 导入 ethers.js
import i18n from './locales'  // ✅ 确保路径正确，指向您的 i18n 实例文件
import './assets/doge-theme.css';

import store from './store'; // 导入 Vuex store

import Web3 from 'web3'
Vue.prototype.ethers = ethers; // 挂载 ethers 到 Vue 原型，如果需要在组件中直接使用

Vue.prototype.Web3 = Web3
Vue.use(MessageDialogPlugin); // 注册插件


// axios.defaults.timeout = 5000 // 请求超时
// axios.defaults.baseURL = '/api'

Vue.config.productionTip = false;

Vue.prototype.$axios = axios;


const env = process.env.NODE_ENV;
Vue.prototype.$address = '';
// 默认是本地环境
if (env === 'production') {
  // 生产环境
  Vue.prototype.$address = 'https://api.school.itnas.cn';
} else {
  // 本地环境
  Vue.prototype.$address = 'http://127.0.0.1:8090';
}

// 关键：全局注册 formatAddress 方法
Vue.prototype.formatAddress = function (address) {
  if (!address) return '';
  return address.substring(0, 6) + '...' + address.substring(address.length - 4);
};

new Vue({
  router,
   store, // 在 Vue 实例中注册 store
    i18n,
  render: (h) => h(App),
}).$mount('#app');
